import localforage from 'localforage'; // ... or any other web storage library
import { AuthStore, type WebStorage } from '@tomra/client-side-authentication';
import { KEYCLOAK_HOST } from '$lib/env';

const storage: WebStorage = {
  setItem: localforage.setItem,
  removeItem: localforage.removeItem,
  clear: localforage.clear,
  getItem: localforage.getItem
};

export const authentication = new AuthStore(
  'TomraConnectUsers',
  'rvm-software-manager-ui',
  KEYCLOAK_HOST,
  'en-US',
  storage
);
